import { EntityService } from './EntityService';

export class OutOfOfficeSettingsService extends EntityService {
    constructor() {
        super("MailboxManager/OutOfOfficeSettings");
    }
}